import isNumber from '@/shared/utils/is-number';

export default function isValidLongitude(longitude: unknown): boolean {
  return isNumber(longitude) && longitude >= -180 && longitude <= 180;
}
